export const fileSize = (size: number) => {
  const i = Math.floor(Math.log(size) / Math.log(1024))
  return Math.floor(size / Math.pow(1024, i)) + ['B', 'kB', 'MB', 'GB', 'TB'][i]
}
